export default {
    authenticate (data) {
        localStorage.setItem('user_cnhu', JSON.stringify(data.user))
        //localStorage.setItem('access_token', data.token)
        //this.setToken(data.access_token)
        //console.log(data)
    },
    setToken (access_token){
        localStorage.setItem('access_token', access_token)
    },
    getToken () {
        let u = JSON.parse(localStorage.getItem('user_cnhu'))
        if (u) {
            return u
        } else return null
    },

    getSession () {
      let item = localStorage.getItem('user_cnhu')
      if (item !== null){
        let user = JSON.parse(item)
        return user.token
      }else return null
    },

    getProfile () {
      let item = localStorage.getItem('user_cnhu')
      if (item !== null){
        let user = JSON.parse(item)
        return user.profile
      }else return null
    },

    getId () {
      let item = localStorage.getItem('user_cnhu')
      if (item !== null){
        let user = JSON.parse(item)
        return user.id
      }else return null
    },

    logout () {
      delete localStorage.user_cnhu
    },

    loggedIn () {
        return !!localStorage.user_cnhu
    },
}
